import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AdvisoryModel, IdInterface, TestResultInterface } from '../data';
import { TestProvider } from '../providers/test.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface GetTestResultsUseCaseParams {
    clientId: IdInterface;
    advisoryModel?: AdvisoryModel;
}

@Injectable()
export class GetTestResultsUseCase implements UseCaseWithParam<GetTestResultsUseCaseParams, Observable<Transaction<TestResultInterface>>> {
    constructor(private testProvider: TestProvider) {}

    bind(params: GetTestResultsUseCaseParams): Observable<Transaction<TestResultInterface>> {
        return this.testProvider.results(params.clientId, params.advisoryModel || AdvisoryModel.C);
    }
}
